/**
 * @param { Object } params = an object of params
 * @returns { String } containing the serialized request params
 */
export const serializeRequestParams = params => {
  if (!params) {
    return "";
  }

  const test = Object.keys(params).reduce((memo, key, i) => {
    const separator = i === 0 ? "?" : "&";
    const value = params[key];
    if (value) {
      memo += `${separator}${key}=${value}`;
    }

    return memo;
  }, "");

  return test;
};

/**
 * Creates a Facebook share link. Any tracking parameters added will be passed through to the link params.
 */
export const createFacebookShare = ({ url, title }) => {
  const baseURL = "http://facebook.com/sharer.php";
  const params = {
    u: encodeURIComponent(url),
    title: encodeURIComponent(title)
  };

  const query = serializeRequestParams(params);
  return `${baseURL}${query}`;
};

/**
 * Creates a Pinterest share link. Any tracking parameters added will be passed through to the link params.
 * Using the logic above, monatizable links will be passed through, otherwise we use CMG links
 */
export const createPinterestShare = ({ url, title, media, description }) => {
  const baseURL = "https://www.pinterest.com/pin/create/link/";
  const sharableURL = url;
  description = encodeURIComponent(description || title);
  const query = serializeRequestParams({
    description,
    media,
    url: sharableURL
  });

  return `${baseURL}${query}`;
};

/**
 * Creates a Email share link.
 * TODO This should probably be a small template
 */
export const createEmailShare = ({ title, url, name, body, subject }) => {
  if (!url) {
    return "";
  }
  subject = subject || encodeURIComponent("I think you would like...");
  name = name || "Shop My Mom ❤️";
  body = body
    ? encodeURIComponent(body)
    : encodeURIComponent(`I just found this on ${name}—check it out: `);
  const mailTitle = encodeURIComponent(title).replace(/\'/g, "%27");
  const params = {
    subject: `${subject}`,
    body: `${body}%0A%0D${mailTitle}%0A%0D${url}`
  };
  const query = serializeRequestParams(params);

  return `mailto:${query}`;
};



// WEBPACK FOOTER //
// ./src/Components/social.js